import './Skills.scss'
import {motion} from 'framer-motion'
import {useState,useEffect} from 'react'
import {Tooltip as ReactTooltip} from 'react-tooltip'
import {urlFor, client} from '../../client'
import {AppWrap, MotionWrap} from '../../wrapper'

import React from 'react'

const Skills = () => {
  const [skills, setSkills] = useState([])
  const [experiences, setExperiences] = useState([])

  useEffect(() => {
    const query = '*[_type == "experiences"]'
    const skillsQuery = '*[_type == "skills"]'

    client.fetch(query).then((data) => {
      setExperiences(data)
    })

    client.fetch(skillsQuery).then((data) => {
      setSkills(data)
    })
    
  }, [])
  
  

  return (
<>
  <h2 className="head-text">skills & experience</h2>
  <div className="app__skills-container">
    <motion.div
      className='app__skills-list'
    >
      {skills.map((skill) => (
        <motion.div
          whileInView={{opacity: [0,1]}}
          transition={{duration: 0.5}}
          key={skill.name}
          className='app__skills-item app__flex'
        >
          <div className="app__flex" style={{backgroundColor: skill.bgColor}}>
            <img src={urlFor(skill.icon)} alt={skill.name} />
          </div>
          <p className="p-text">{skill.name}</p>
        </motion.div>  
      ))}
    </motion.div>

    <div className="app__skills-exp">
      {experiences.length ? (experiences?.map((experience) => (
        <motion.div
        className='app__skills-exp-item'
        key={experience.year}
        >
          <div className="app__skills-exp-year">
            <p className="p-text">{experience.year}</p>
          </div>

          <motion.div 
            className='app__skill-exp-works'
          >
            {experience.works.map((work) => (
            <>  
              <motion.div
                whileInView={{opacity: [0,1]}}
                transition={{duration: 0.5}}
                data-tooltip-content={work.desc}
                data-tooltip-id={work.name}
                key={work.name}
                className='app__skills-exp-work'
              >
                <h4 className="bold-text">{work.name}</h4>
                <p className="p-text">{work.company}</p>
              </motion.div>
              <ReactTooltip
                id={work.name}
                effect="solid"
                arrowColor="#fff"
                className="skills-tooltip"
              />
            </>  
            ))}

          </motion.div>
        </motion.div>
      ))
      ) : (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width:'100%', height: '100%'}}>
          <p className='p-text' style={{fontSize: '1.1rem'}}>Experience section is empty for now but soon will have something to convey.</p>
        </div>
      )
    }  
    </div>   

  </div> 
</>
  )
}

export default AppWrap(
  MotionWrap(Skills,'app__skills'),
  'skills'
  ,'app__whitebg')